import React from "react";
import { AdaptiveSearchBarProps } from "@/components/pages/home/components/searchbar/searchbar";
import styles from "@/components/pages/home/components/searchbar/styles/searchbar.module.scss";
import GenderSelector from "@/components/pages/home/components/searchbar/components/gender-selector";
import FiltersContainer from "@/components/pages/home/components/searchbar/components/filters-container";
import SearchBarContainer from "@/components/pages/home/components/searchbar/components/searchbar-container";
import FiltersCardsContainer from "@/components/pages/home/components/searchbar/components/filters-cards-container";
import { useTablet } from "@/hooks/use-responsive";
import $filters from "@/data/filters.constants";
import FilterButtons from "@/components/pages/home/components/searchbar/components/filter-buttons";
import { useCategoriesDropdownContext } from "@/components/pages/home/providers/categories-dropdown-provider";
import { DropdownSelectorOption } from "@/components/pages/home/components/searchbar/components/dropdown";

const MobileSearchbar = ({
  onSelectGender,
  onSearch,
  filters,
  handleFilterClick,
  selectedFilter,
  scrollY,
}: AdaptiveSearchBarProps) => {
  const { isTablet } = useTablet();
  const { setValue } = useCategoriesDropdownContext();
  const onSelectFilter = (filter: DropdownSelectorOption) => {
    handleFilterClick(filter);
    setValue(filter);
  };
  return (
    <div className={styles.searchbar}>
      {isTablet && (
        <FiltersCardsContainer
          selectedFilter={selectedFilter}
          onSelectFilter={onSelectFilter}
          scrollY={scrollY}
        />
      )}
      <SearchBarContainer onSearch={onSearch} />
      <div className={styles.searchbar_filters}>
        <GenderSelector onSelectGender={onSelectGender} />
        <div className={styles.filters_wrapper}>
          <FiltersContainer
            selectedFilter={selectedFilter}
            onSelectFilter={onSelectFilter}
            filters={filters}
            displayCreateCustomVoice={true}
          />
        </div>
      </div>
      {!isTablet && (
        <FilterButtons
          key={scrollY}
          filters={$filters.cardFilters}
          selectedFilter={selectedFilter}
          onSelectFilter={onSelectFilter}
          scrollY={scrollY}
        />
      )}
    </div>
  );
};

export default MobileSearchbar;
